import * as THREE from 'three';

// The glyph atlas of visualizers/matrix.js, built by tools/build-matrix-
// atlas.mjs: a 256 px signed-distance PNG of 64 characters and its manifest
// (the glyph order, which are mirrored, where the Latin capitals and digits
// start - what maps a title to indices). Loaded once at application
// startup, like crowd-atlas.js, and handed to whoever asks; the visualizer
// reads it with the synchronous getter and runs in CODE mode without the
// hidden text if it is missing. RELATIVE urls, for the Tizen app's file://
// origin (see crowd-atlas.js).
const MANIFEST = 'textures/matrix-atlas.json';

let _promise = null;
let _atlas = null;

function configure(texture) {
  texture.colorSpace = THREE.NoColorSpace;
  texture.wrapS = texture.wrapT = THREE.ClampToEdgeWrapping;
  texture.minFilter = THREE.LinearFilter;
  texture.magFilter = THREE.LinearFilter;
  texture.generateMipmaps = false;
  texture.needsUpdate = true;
  return texture;
}

// Resolves to { texture, meta } or to null, said in the console once.
export function preloadMatrixAtlas() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST)
    .then(function (r) { if (!r.ok) throw new Error('matrix-atlas.json HTTP ' + r.status); return r.json(); })
    .then(function (meta) {
      return new Promise(function (resolve, reject) {
        new THREE.TextureLoader().load('textures/' + meta.png, function (t) { resolve({ texture: configure(t), meta: meta }); }, undefined, function () { reject(new Error(meta.png + ' failed to load')); });
      });
    })
    .then(function (a) { _atlas = a; return a; })
    .catch(function (err) {
      console.error('[party-mode] matrix atlas unavailable, Matrix will not be offered', err);
      _atlas = null;
      return null;
    });
  return _promise;
}

export function getMatrixAtlas() { return _atlas; }
